import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Instagram, Calendar } from 'lucide-react';
export function Contact() {
  return <section id="contacto" className="py-24 bg-dark" data-id="element-12">
      <div className="container mx-auto px-6" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-15">
            <h2 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-16">
              Visitá <span className="text-gold" data-id="element-17">Prince</span>
            </h2>

            <div className="space-y-8 mb-10" data-id="element-18">
              <div className="flex items-start gap-4" data-id="element-19">
                <div className="w-12 h-12 rounded-full bg-dark-surface flex items-center justify-center shrink-0 border border-white/5" data-id="element-20">
                  <MapPin className="text-gold w-5 h-5" data-id="element-21" />
                </div>
                <div data-id="element-22">
                  <h4 className="font-bold text-lg mb-1" data-id="element-23">Ubicación</h4>
                  <p className="text-gray-400" data-id="element-24">
                    Av. Carlos María Ramírez 275
                    <br data-id="element-25" />
                    Montevideo, Uruguay
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-26">
                <div className="w-12 h-12 rounded-full bg-dark-surface flex items-center justify-center shrink-0 border border-white/5" data-id="element-27">
                  <Phone className="text-gold w-5 h-5" data-id="element-28" />
                </div>
                <div data-id="element-29">
                  <h4 className="font-bold text-lg mb-1" data-id="element-30">Teléfono</h4>
                  <a href="tel:091414192" className="text-gray-400 hover:text-gold transition-colors" data-id="element-31">
                    091 414 192
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-32">
                <div className="w-12 h-12 rounded-full bg-dark-surface flex items-center justify-center shrink-0 border border-white/5" data-id="element-33">
                  <Instagram className="text-gold w-5 h-5" data-id="element-34" />
                </div>
                <div data-id="element-35">
                  <h4 className="font-bold text-lg mb-1" data-id="element-36">Instagram</h4>
                  <a href="https://instagram.com/princebarberstudio" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gold transition-colors" data-id="element-37">
                    @princebarberstudio
                  </a>
                </div>
              </div>
            </div>

            <a href="https://book.weibook.co/princebarberstudio" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-light text-dark font-semibold px-8 py-4 rounded-sm transition-all duration-300 w-full sm:w-auto" data-id="element-38">
              <Calendar size={20} data-id="element-39" />
              RESERVÁ TU TURNO
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="h-[400px] lg:h-[500px] bg-dark-surface rounded-sm border border-white/10 overflow-hidden relative" data-id="element-40">
            {/* Map Placeholder - In a real scenario, embed a Google Map iframe here */}
            <div className="absolute inset-0 flex flex-col items-center justify-center text-gray-500 p-6 text-center" data-id="element-41">
              <MapPin className="w-12 h-12 mb-4 opacity-50" data-id="element-42" />
              <p className="font-medium" data-id="element-43">
                Av. Carlos María Ramírez 275, Montevideo
              </p>
              <p className="text-sm mt-2 opacity-70" data-id="element-44">
                Mapa interactivo no disponible en vista previa
              </p>
            </div>
            {/* Optional: A subtle gradient overlay to make it look intentional */}
            <div className="absolute inset-0 bg-gradient-to-tr from-dark/80 to-transparent pointer-events-none" data-id="element-45"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}